import { Navigate, Outlet, useParams } from '@tanstack/react-router';

import { useInventoryServiceFeatureEnabled } from '../common/hooks/useWarehouseFeatureEnabled';

const OpsOptimisedUiEnabledRoute = () => {
  /* There are still venues that rely on Wolt menu for inventory, and since the new ops-optimized receiving tool
  does not support that use case, we need to redirect them to the legacy receiving tool. */
  const enabled = useInventoryServiceFeatureEnabled();
  const { warehouseId } = useParams({ strict: false });

  if (enabled) {
    return <Outlet />;
  }

  if (warehouseId) {
    return <Navigate to="/receiving/warehouse/$warehouseId" params={{ warehouseId }} />;
  }

  return <Navigate to="/receiving" />;
};

export default OpsOptimisedUiEnabledRoute;
